export var PendingTransactionsMapper = function (response) {
    return response;
};
export var PendingTransactionByIdMapper = function (response) {
    return response;
};
export var AssignToSelfMapper = function (response) {
    return response;
};
export var UpdateApproveRejectStatusMapper = function (response) {
    return response;
};
export var DocumentListMapper = function (response) {
    return response;
};
export var DocumentDetailsMapper = function (response) {
    return response;
};
export var ModifyTransactionMapper = function (response) {
    return response;
};
export var FolioDetailsMapper = function (response) {
    return response;
};
export var PendingCountMapper = function (response) {
    return response;
};
export var DownloadPendingTransactionMapper = function (response) {
    return response;
};
export var UploadDocsMapper = function (response) {
    return response;
};
export var DeleteDocsMapper = function (response) {
    return response;
};
